import React from 'react'
import type { Theme } from '@material-ui/core'
import { makeStyles } from '@material-ui/core'
import Highlight from '@paintscout/ui/components/Highlight'
import Typography from '@paintscout/ui/components/Typography'
import type { ActivityTypeComponentProps } from '../Activity'
import ActivityDot from '../ActivityDot'
import ActivityFooter from '../ActivityFooter'
import ActivityOwner from '../ActivityOwner'
import ActivityTitle from '../ActivityTitle'

const useStyles = makeStyles<Theme>(
  (theme) => ({
    root: {
      opacity: 0.65
    },
    eventList: {
      margin: 0,
      paddingLeft: theme.spacing(3)
    },
    eventItem: {
      lineHeight: 1.4
    }
  }),
  {
    name: 'SettingsEditedActivity'
  }
)

/**
 * Renders an admin-only `settings-edited` activity. Each entry in the
 * activity's `events` array is shown as a bullet describing one change
 * (rate created, line item edited, toggle flipped, etc.). The whole row is
 * rendered with reduced opacity so the support team can spot admin-only
 * activities at a glance against the main feed.
 */
export default function SettingsEditedActivity(props: ActivityTypeComponentProps) {
  const classes = useStyles(props)
  const { activity } = props
  const events = activity.details.events ?? []

  return (
    <div className={classes.root}>
      <ActivityTitle>
        <ActivityDot activity={activity} />
        <Highlight>Settings updated</Highlight>
        <ActivityOwner activity={activity} />
      </ActivityTitle>
      {events.length > 0 && (
        <ul className={classes.eventList}>
          {events.map((event, idx) => (
            <li key={idx} className={classes.eventItem}>
              <Typography variant="body2" color="textSecondary">
                {event}
              </Typography>
            </li>
          ))}
        </ul>
      )}
      <ActivityFooter timestamp={activity.details.timestamp} />
    </div>
  )
}
